import SimpleModal from "../../../../components/SimpleModal";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { createLevel } from "../../studentSlice";

export const LevelCreateModal = ({ setIsLevelModalOpen }) => {
  const dispatch = useDispatch();

  const [levelName, setLevelName] = useState("");

  const handleLevelSubmit = async () => {
    try {
      await dispatch(createLevel({ name: levelName })).unwrap();
      alert("반이 추가되었습니다.");
      setIsLevelModalOpen(false);
    } catch (err) {
      alert("반 추가에 실패했습니다.");
    }
  };

  return (
    <SimpleModal
      title="반 추가하기"
      onClose={() => setIsLevelModalOpen(false)}
      onSubmit={handleLevelSubmit}
      buttonText="추가하기"
    >
      <div style={{ paddingBottom: "20px" }}>
        <input
          type="text"
          placeholder="클래스 이름을 입력하세요."
          value={levelName}
          style={{
            padding: "8px 12px",
            borderRadius: "5px",
            border: "1px solid #2D2D2D",
            width: "370px",
          }}
          onChange={(e) => setLevelName(e.target.value)}
        />
      </div>
    </SimpleModal>
  );
};
